import { useCallback, useEffect, useState } from 'react';

/** Jerarquía completa (incluye inactivos) para validar borrado masivo. */
export function useClassificationHierarchyForBulk(apiService, refreshKey = 0) {
  const [hierarchy, setHierarchy] = useState([]);

  const load = useCallback(async () => {
    if (!apiService?.getHierarchy) return;
    try {
      const res = await apiService.getHierarchy({ active_only: false });
      if (res?.success) setHierarchy(res.data || []);
    } catch {
      setHierarchy([]);
    }
  }, [apiService]);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return { hierarchy, reloadHierarchy: load };
}
